/**
 * Provides the toast injection map consumed by {@link useToast}.
 * Vendored from `layers/ui` so the toast system works without the submodule.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(toastInjectionKey, reactive(new Map()))
})
